<template>
  <section class="cloud-storage-file-operate" v-show="isShowed" :style="{top: top + 'px'}">
    <i-card style="width:180px">
      <div v-show="panel==='panel1'">
        <div class="l-flex-start height-50 l-padding-left-sm option" @click="moveItem" v-show="hasShare">
          <i class="icon-move l-margin-right-sm"></i>
          <p class="text-mid text-blakc-000">移动到</p>
        </div>
        <div class="l-flex-start height-50 l-padding-left-sm option" @click="renameItem" v-show="hasShare">
          <i class="icon-edit l-margin-right-sm"></i>
          <p class="text-mid text-blakc-000">重命名</p>
        </div>
        <div class="l-flex-start height-50 l-padding-left-sm option" @click="shareItem" v-show="hasShare">
          <i class="icon-share l-margin-right-sm"></i>
          <p class="text-mid text-blakc-000">分享</p>
        </div>
        <div class="l-flex-start height-50 l-padding-left-sm option" @click="deleteItem" v-show="hasShare">
          <i class="icon-delete l-margin-right-sm"></i>
          <p class="text-mid text-blakc-000">删除</p>
        </div>
      </div>
      <div v-show="panel==='panel2'">
        <div class="l-flex-start height-50 l-padding-left-sm option" @click="copyLink" v-show="hasShare">
          <i class="icon-copy l-margin-right-sm"></i>
          <p class="text-mid text-blakc-000">复制分享链接</p>
        </div>
        <div class="l-flex-start height-50 l-padding-left-sm option" @click="cancelShareItem" v-show="hasShare">
          <i class="icon-share l-margin-right-sm"></i>
          <p class="text-mid text-blakc-000">取消分享</p>
        </div>
      </div>
    </i-card>
  </section>
</template>

<script>

import { Card } from 'iview'

export default {
  name: 'FileOperate',
  data () {
    return {
    }
  },
  computed: {
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    },
    hasShare: {
      type: Boolean,
      default: true
    },
    top: {
      type: Number,
      default: 0
    },
    panel: {
      type: String,
      default: 'panel1'
    }
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  methods: {
    cancelModel () {
      this.$emit('change-show', false) // 关闭弹窗
    },
    moveItem () {
      this.$emit('move')
      this.$emit('change-show', false)
    },
    renameItem () {
      this.$emit('rename')
      this.$emit('change-show', false)
    },
    shareItem () {
      this.$emit('share')
      this.$emit('change-show', false)
    },
    deleteItem () {
      this.$emit('delete')
      this.$emit('change-show', false)
    },
    copyLink () {
      this.$emit('copyLink')
      this.$emit('change-show', false)
    },
    cancelShareItem () {
      this.$emit('cancelShare')
      this.$emit('change-show', false)
    }
  },
  components: {
    'i-card': Card
  }
}
</script>

<style lang="stylus">
.cloud-storage-file-operate
  position: absolute
  z-indx: 9999
  right: 0
  .ivu-card-body
    padding: 0
  .icon-move
    bg-icon(16px, 16px, '../../assets/cloudstorage/icon-move.png')
  .icon-edit
    bg-icon(16px, 16px, '../../assets/cloudstorage/icon-edit.png')
  .icon-share
    bg-icon(16px, 16px, '../../assets/cloudstorage/icon-share.png')
  .icon-delete
    bg-icon(16px, 16px, '../../assets/cloudstorage/icon-delete.png')
  .icon-copy
    bg-icon(16px, 16px, '../../assets/cloudstorage/icon-copy.png')
  .height-50
    height: 50px
    width: 180px
  .option:hover
    background: #f6f6f6
</style>



// WEBPACK FOOTER //
// src/components/cloudstorage/FileOperate.vue